import { shortenNumber } from '@ydistri/generic-utils';
import { StatisticItem } from '../StatisticsSummary';
import { CalculationStatisticStoreSourceResponse } from '@ydistri/api-sdk';

export const buildSourceStoreStats = (
  sourceStores: CalculationStatisticStoreSourceResponse[] | undefined | null,
  hasDepartments: boolean,
  currency: string,
): StatisticItem[] => {
  const totalValue = sourceStores?.reduce((sum, r) => sum + r.value, 0) ?? 0;
  const totalQuantity = sourceStores?.reduce((sum, r) => sum + r.quantity, 0) ?? 0;
  const totalPickingPositions =
    sourceStores?.reduce((sum, r) => sum + r.pickingPositionCount, 0) ?? 0;
  const count = sourceStores?.length ?? 0;

  return [
    { title: `Source Store${hasDepartments ? '-Department' : ''}s`, value: count },
    { title: 'Picking Positions', value: shortenNumber(totalPickingPositions) },
    { title: `Value (${currency})`, value: shortenNumber(totalValue) },
    { title: 'Quantity', value: shortenNumber(totalQuantity) },
  ];
};
